import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { WebsitePage } from '../../layouts/WebsitePage'
import { unsubscribe } from '../../requests/userSettings'
import { handleError } from '../../errors/handleError'
// import './styles.css'

export const Unsubscribe: React.FC = () => {
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)
  const loc = useLocation()

  const onUnsubscribe = async () => {
    const uParam = new URLSearchParams(loc.search).get('u')

    try {
      const res = await unsubscribe({
        u: uParam
      })

      if (res.data.success) {
        setSuccess(true)
      }
    } catch (err) {
      handleError(err, 'Something went wrong while unsubscribing the user.')
      setError(true)
    }
  }
  return (
    <WebsitePage>
      <div id="unsubscribe">
        <h2>Unsubscribe from email notifications</h2>

        {
          error && (
            <p>Something went wrong. Please try again later.</p>
          )
        }

        { !success && (
          <button className="primary" type="button" onClick={onUnsubscribe}>
            Unsubscribe
          </button>
        )}

        { success && (
          <h4>You have been unsubscribed from email notifications.</h4>
        )}


        <sub>You can always log in and go to your settings to turn notifications back on.</sub>
      </div>
    </WebsitePage>
  )
}

